import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** shadcn/ui-style className merge: clsx conditionals + tailwind-merge dedup. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
